module.exports = __webpack_public_path__ + "assets/images/compass-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/compass-on.png
// module id = 1512
// module chunks = 1